import { render, staticRenderFns } from "./GerarOrdemColeta.vue?vue&type=template&id=653cc4f6"
import script from "./GerarOrdemColeta.vue?vue&type=script&lang=js"
export * from "./GerarOrdemColeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports